import { useQuery } from '@tanstack/react-query';
import { ClientSearchResult } from 'src/models/user/_types';
import { User } from 'src/models/user/_types';
import { fetchUsers } from 'src/models/user/user';
import { getUserDisplayName } from 'src/models/user/utils';
import { ClientAutocomplete } from 'src/pages/Clients/WaiverPage/ClientAutocomplete';
import { Identifier } from 'src/types/utilityTypes';

interface ClientFilterProps {
  label: string;
  value: Identifier | undefined;
  setValue: (newVal?: Identifier) => void;
  valueOnly?: boolean;
  useUserId?: boolean; // If true, stores/returns user ID instead of clientId
}

export const ClientFilter: React.FC<ClientFilterProps> = ({
  label,
  value,
  setValue,
  valueOnly,
  useUserId = false,
}) => {
  const { data: users } = useQuery<User[]>({
    queryKey: ['users', value, useUserId],
    queryFn: () =>
      useUserId
        ? fetchUsers({ ids: [value!] })
        : fetchUsers({ clientId: value! }),
    enabled: !!value,
  });

  const user = users?.[0];

  if (valueOnly) {
    return <>{getUserDisplayName(user)}</>;
  }

  const client = user
    ? {
        id: user.id,
        name: getUserDisplayName(user) || '',
        profileImage: user.profileImage || '',
        clientId: user.trainerAssociationId || user.id,
      }
    : null;

  return (
    <ClientAutocomplete
      label={label}
      value={client}
      onChange={(newValue) => {
        const result = newValue as ClientSearchResult;
        setValue(useUserId ? result?.id : result?.clientId);
      }}
    />
  );
};
